import { render, staticRenderFns } from "./CreateBackupRepository.vue?vue&type=template&id=31ff3a49&"
import script from "./CreateBackupRepository.vue?vue&type=script&lang=ts&"
export * from "./CreateBackupRepository.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports